import axios from "@/helpers/axios";
import confetti from "canvas-confetti";
import searchManager from "@/components/modal/SearchManager/index.vue";
import policyPopup from "@/components/modal/policyPopup/layout.vue";
import registerCardModal from "@/components/modal/RegisterCard/index.vue";
import stepProgress from "vue-step-progress";
import channelTalk from "@/helpers/channelTalk";
import "../progressbar.css";

export default {
  metaInfo: {
    title: "구성원 회원가입",
  },

  components: {
    searchManager,
    stepProgress,
    registerCardModal,
    policyPopup,
  },
  data() {
    return {
      registeredFrom: "MODAL",
      openRegisterCardModal: false,
      select: false,
      parentId: "",
      openSearchManager: false,
      policyType: "",
      openPolicyPopup: false,
      isAgreePolicy: {
        service: false,
        privacy: false,
        marketing: false,
      },
      isLoading: false,

      content1: {
        companyName: "",
      },
      content2: {},

      progressLibraryOption: {
        mySteps: ["", ""],
        currentStep: 0,
        activeColor: "#0081ea",
        passiveColor: "#ecf0f3",
        lineThickness: 2,
      },

      idContent: [
        {
          type: "text",
          label: "아이디",
          name: "userId",
          errorBehavior: "value",
          placeholder: "4자 이상 입력",
          validation: [["required"], ["idValidation"]],
        },
      ],
      passwordContent: [
        {
          type: "toggable-password",
          label: "비밀번호",
          name: "password",
          errorBehavior: "value",
          placeholder: "영문/숫자 조합 10자 이상 입력",
          validation: [["required"], ["passwordValidation"]],
        },
      ],

      step: 1,

      completeCardList: [
        {
          title: "결제카드 등록",
          subTitle: "결제 시 이용할 카드를<br/> 미리 등록해 보세요!",
          value: "card",
          imgNum: 0,
        },
        {
          title: "자주묻는 질문(FAQ)",
          subTitle: "디버에게 궁금한 점이 있나요?<br/> 해결해 드릴게요!",
          value: "faq",
          imgNum: 2,
        },
        {
          title: "배송운임표",
          subTitle: "디버의 합리적인 운임을<br/> 확인해 보세요!",
          value: "deliveryFee",
          imgNum: 3,
        },
        {
          title: "고객센터 연결",
          subTitle: "디버의 챗봇 문의 화면으로<br/> 바로 연결해 드릴게요!",
          value: "chatbot",
          imgNum: 4,
        },
      ],
    };
  },
  watch: {
    step(newVal) {
      if (newVal === 3) {
        const myCanvas = document.getElementById("complete");
        const myConfetti = confetti.create(myCanvas, {
          resize: true,
          useWorker: true,
        });

        myConfetti({
          particleCount: 50,
          spread: 70,
          origin: {
            y: 0.7,
          },
        });
      }
    },
  },
  computed: {
    isAllCheck() {
      if (
        !this.isAgreePolicy.service ||
        !this.isAgreePolicy.privacy ||
        !this.isAgreePolicy.marketing
      )
        return false;

      return true;
    },
  },
  methods: {
    trimOnBlur(key) {
      this.content2[key] = this.content2[key].replace(/\s/g, "");
    },

    customTrim(value) {
      value = value.replace(/ +/g, " ");
      value = value.replace(/^\s+|\s+$/g, "");
      return value;
    },

    //주문접수 페이지로 이동
    routeOrderPage() {
      this.$router.push("/orders/form");
    },

    //회사/단체명 검색
    selectManager(val) {
      this.openSearchManager = false;
      this.content1.companyName = val.companyName;
      this.parentId = val._id;
    },

    //정책 popup 오픈
    openPolicy(type) {
      this.policyType = type;
      this.openPolicyPopup = true;
    },

    openPrivacyPolicy() {
      window.open(
        "https://static.dver.co.kr/privacy-terms/latest.pdf ",
        "_blank"
      );
    },

    //카드별 리다이렉트 정의
    cardRoute(type) {
      if (type === "card") {
        this.openRegisterCardModal = true;
      }
      if (type === "faq") {
        return this.$router.push("/services/faq");
      }
      if (type === "deliveryFee") {
        return window.open(
          "https://dvercorp-co-kr.imgix.net/dver/notice/230119_%E1%84%83%E1%85%B5%E1%84%87%E1%85%A5%20%E1%84%87%E1%85%A2%E1%84%89%E1%85%A9%E1%86%BC%E1%84%8B%E1%85%AE%E1%86%AB%E1%84%8B%E1%85%B5%E1%86%B7%20%E1%84%8B%E1%85%A1%E1%86%AB%E1%84%82%E1%85%A2.png"
        );
      }
      if (type === "chatbot") {
        channelTalk.openChat();
      }
    },

    //ID 중복 체크
    async checkExistUser() {
      this.isLoading = true;

      try {
        const result = await this.$store.dispatch(
          "checkId",
          this.content2.userId
        );
        if (result.existingUser === "NNNNY") {
          alert("이미 사용 중인 아이디에요.");
          this.isLoading = false;
          return false;
        }
        return this.submit();
      } catch (e) {
        this.isLoading = false;
        alert("회원가입중 오류가 발생하였습니다");
      }
    },

    //회원가입 로직 실행
    async submit() {
      const payload = {
        parentId: this.parentId,
        userId: this.content2.userId,
        password: this.content2.password,
        name: this.content1.name,
        phoneNumber: this.content1.phoneNumber,
        department: this.content1.department,
        isAgreedToService: this.isAgreePolicy.service,
        isAgreedToPrivacyPolicy: this.isAgreePolicy.privacy,
        isAgreedToMarketing: this.isAgreePolicy.marketing,
      };

      try {
        const result = await this.$store.dispatch("biz_member_signup", payload);
        if (!result.success) {
          console.error(result);
          if (result.code === 409) {
            this.isLoading = false;
            return alert("이미 존재하는 아이디입니다.");
          }
          this.isLoading = false;
          return alert("요청에 오류가 발생하였습니다");
        } else {
          this.$store.dispatch("auth/updateAccessToken", result.accessToken);
          this.$store.dispatch("auth/updateRefreshToken", result.refreshToken);
        }
        return (
          (this.step = this.step + 1),
          channelTalk.boot(),
          window.scrollTo(0, 0),
          (this.isLoading = false)
        );
      } catch (e) {
        this.loading = false;
        alert("회원가입중 오류가 발생하였습니다");
      }
    },

    //이전
    prev() {
      if (this.step === 1) {
        return this.$router.push("/join/intro");
      }
      this.step = this.step - 1;
      window.scrollTo(0, 0);
    },

    //다음
    next() {
      if (this.step === 1) {
        this.content1.department = this.customTrim(this.content1.department);
        this.content1.name = this.customTrim(this.content1.name);
      }
      this.step = this.step + 1;
      this.progressLibraryOption.currentStep = this.step - 1;
      window.scrollTo(0, 0);
    },

    checkAll() {
      const values = Object.values(this.isAgreePolicy);

      const isAllTrue = values.every(function (value) {
        return value;
      });

      Object.keys(this.isAgreePolicy).forEach(
        (key) => (this.isAgreePolicy[key] = isAllTrue ? false : true)
      );
    },
  },
  mounted() {},
};
